import { render, staticRenderFns } from "./notice-add-or-update.vue?vue&type=template&id=3a58fa46&scoped=true&"
import script from "./notice-add-or-update.vue?vue&type=script&lang=js&"
export * from "./notice-add-or-update.vue?vue&type=script&lang=js&"
import style0 from "./notice-add-or-update.vue?vue&type=style&index=0&id=3a58fa46&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a58fa46",
  null
  
)

export default component.exports